import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[lang]/error.tsx");
